<template>
    <v-card>
        <s-crud :config="config" title="Asignación de equipos" :filter="filter" excel search-input
            :remove="itemSelected ? (itemSelected.EanStatus ? true : false) : false" ref="scrudEquipmentAssignament"
            @rowSelected="rowSelected($event)" :configuration="this.$fun.isAdmin()"
            nameScrud="scrudEquipmentAssignament" height="480px">
            <template v-slot:filter>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="3">
                            <s-select-definition :def="1531" label="Tipo Asignación" v-model="filter.CgeTypeAssigns"
                                clearable />
                        </v-col>
                        <v-col cols="12" md="3" v-if="filter.CgeTypeAssigns == 1 || filter.CgeTypeAssigns == 2">
                            <s-select-area label="Area" v-model="filter.AreID" />
                        </v-col>
                        <v-col cols="12" md="3" v-if="filter.CgeTypeAssigns == 3">
                            <s-select-definition :def="1534" label="Zona" v-model="filter.EanZone" />
                        </v-col>
                        <v-col cols="12" md="3">
                            <s-date v-model="filter.EanDateFrom" label="Fecha desde" clearable />
                        </v-col>
                        <v-col cols="12" md="3">
                            <s-date v-model="filter.EanDateUntil" label="Fecha hasta" clearable />
                        </v-col>
                        <v-col cols="12" md="3">
                            <s-switch label="Mostrar Inactivos" v-model="filter.EanStatus" :true-value="0"
                                :false-value="1" />
                        </v-col>
                    </v-row>
                </v-container>
            </template>

            <template v-slot:AsgDevolution="{ row }">
                <v-btn v-if="row.EanStatus == 0 ? false : true" x-small color="success" @click="AsgDevolution(row)">
                    <v-icon>mdi-sync</v-icon>
                </v-btn>
                <v-btn v-else x-small color="primary" @click="AsgDevolutionView(row)">
                    <v-icon>mdi-eye</v-icon>
                </v-btn>
            </template>
            <template v-slot:AsgAction="{ row }">
                <v-btn :disabled="row.EanStatus == 0 ? true : false" x-small color="primary"
                    @click="AsgActionEdit(row)">
                    <i class="fas fa-chalkboard-teacher"></i>
                </v-btn>
            </template>
            <template v-slot:AsgSecStatus="{ row }">
                <v-chip x-small :color="row.EanStatus == 1 ? 'success' : 'error'" class="pl-2 pr-2">
                    {{ row.EanStatus == 1 ? "Activo" : "Inactivo" }}
                </v-chip>
            </template>

            <template v-slot:CtrStatusName="{ row }">
                <v-chip x-small :color="getStatusColor(row.CtrStatusName)" class="pl-2 pr-2">
                    {{ row.CtrStatusName }}
                </v-chip>
            </template>

            <template v-slot:options>
                <v-menu offset-y v-if="itemSelected">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon x-small color="white">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="openDialogPDF(itemSelected)">
                            <v-list-item-icon style="margin-right: 10px">
                                <v-icon>mdi-file-document</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Imprimir Asignación</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="openDialogPDF(itemSelected, true)">
                            <v-list-item-icon style="margin-right: 10px">
                                <v-icon>mdi-file-document</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Imprimir Devolución</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-tooltip bottom="">
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on" small elevation="0" @click="addAssignment()">
                            <i class="fas fa-chalkboard-teacher"></i>
                        </v-btn>
                    </template>
                    <span>Agregar asignación</span>
                </v-tooltip>
            </template>
        </s-crud>

        <v-dialog v-model="dialogAssignment" v-if="dialogAssignment" max-width="1400px" persistent
            transition="dialog-transition" fullscreen>
            <v-card>
                <!-- Header moderno con gradiente -->
                <div class="modern-header">
                    <div class="header-content">
                        <div class="header-left">
                            <v-icon class="header-icon" size="28" color="white">mdi-laptop</v-icon>
                            <div class="header-text">
                                <h2 class="header-title">Asignar Equipo</h2>
                                <p class="header-subtitle">
                                    Gestión de asignación de equipos tecnológicos
                                </p>
                            </div>
                        </div>
                        <div class="header-actions">
                            <v-btn icon large class="clear-btn" @click="clear(true)"
                                :disabled="worker.EanID == '' ? false : true">
                                <v-icon color="white">mdi-refresh</v-icon>
                            </v-btn>
                            <v-btn icon large class="close-btn" @click="dialogAssignment = false">
                                <v-icon color="white">mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>

                <!-- Contenido principal -->
                <div class="dialog-content">
                    <v-container fluid>
                        <!-- Sección de tipo de asignación -->
                        <div class="section-card mb-6">
                            <div class="section-header">
                                <v-icon class="section-icon" color="primary">mdi-format-list-bulleted-type</v-icon>
                                <h3 class="section-title">Tipo de Asignación</h3>
                            </div>
                            <v-row class="mt-4">
                                <v-col cols="12" md="6">
                                    <s-select-definition :def="1531" v-model="filterEquipment.CgeTypeAssigns"
                                        @change="changeTypeAssign()" :disabled="worker.EanID == '' ? false : true"
                                        outlined dense class="modern-input" />
                                </v-col>
                            </v-row>
                        </div>

                        <div class="width-100" style="width: 100%;">
                            <v-row class="" style="">
                                <!-- Panel izquierdo - Datos del trabajador -->
                                <v-col cols="12" lg="6" class="">
                                    <div class="section-card">
                                        <!-- Header del formulario -->
                                        <div class="section-header">
                                            <v-icon class="section-icon" color="success">mdi-account-circle</v-icon>
                                            <h3 class="section-title">Datos del Trabajador</h3>
                                            <v-spacer></v-spacer>
                                            <v-btn color="success" class="save-btn" @click="saveDialog()" elevation="2">
                                                <v-icon left>mdi-content-save</v-icon>
                                                Guardar
                                            </v-btn>
                                        </div>

                                        <div class="form-content mt-2">
                                            <!-- Zona (solo para tipo 3) -->
                                            <v-row v-if="filterEquipment.CgeTypeAssigns == 3" dense>
                                                <v-col cols="12">
                                                    <s-select-definition :def="1534" label="Zona"
                                                        v-model="worker.EanZone" outlined dense class="modern-input" />
                                                </v-col>
                                            </v-row>

                                            <!-- Búsqueda de persona y área -->
                                            <v-row
                                                v-if="filterEquipment.CgeTypeAssigns == 1 || filterEquipment.CgeTypeAssigns == 2"
                                                dense>
                                                <v-col cols="12" sm="6" v-if="filterEquipment.CgeTypeAssigns == 2">
                                                    <s-toolbar-person :noEdit="!$fun.isAdmin()" label="Buscar Persona"
                                                        noCamera v-model="worker.PrsDocumentNumber"
                                                        @returnPerson="returnPerson($event)" class="modern-input" />
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <s-select-area label="Área" v-model="worker.EanArea"
                                                        :text="worker.AreName" v-if="searchAre" outlined dense
                                                        class="modern-input" />
                                                </v-col>
                                            </v-row>

                                            <!-- Nombre completo e ID -->
                                            <v-row v-if="filterEquipment.CgeTypeAssigns == 2" dense>
                                                <v-col cols="12" sm="9" md="9">
                                                    <s-text label="Nombre Completo" v-model="worker.NtpFullName"
                                                        disabled outlined dense class="modern-input" />
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <s-text label="ID" v-model="worker.NtpID" disabled outlined dense
                                                        class="modern-input" />
                                                </v-col>
                                            </v-row>

                                            <!-- Fechas -->
                                            <v-row dense>
                                                <v-col cols="12" sm="4"
                                                    :md="[1, 3].includes(filterEquipment.CgeTypeAssigns) ? 4 : 3">
                                                    <s-date label="Fecha Inicio" v-model="worker.EanDateFrom" outlined
                                                        dense class="modern-input" />
                                                </v-col>
                                                <v-col cols="12" sm="4"
                                                    :md="[1, 3].includes(filterEquipment.CgeTypeAssigns) ? 4 : 3">
                                                    <s-date label="Fecha Fin" v-model="worker.EanDateUntil" clearable
                                                        outlined dense class="modern-input" />
                                                </v-col>
                                                <v-col cols="12" md="2" v-if="filterEquipment.CgeTypeAssigns == 2"
                                                    class="d-flex align-center">
                                                    <v-btn color="info" icon @click="searchDateEnd()"
                                                        class="date-helper-btn">
                                                        <v-icon>mdi-calendar-question</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>

                                            <!-- Datos Técnicos -->
                                            <v-row dense>
                                                <v-col cols="12" sm="4"
                                                    :md="[2].includes(filterEquipment.CgeTypeAssigns) ? 3 : 4">
                                                    <s-text label="Nombre de Usuario" v-model="worker.EanUserName"
                                                        outlined dense class="modern-input" />
                                                </v-col>
                                                <v-col cols="12" sm="4"
                                                    :md="[2].includes(filterEquipment.CgeTypeAssigns) ? 3 : 34">
                                                    <s-text label="Hostname" v-model="worker.EanHostName" outlined dense
                                                        class="modern-input" />
                                                </v-col>
                                                <v-col cols="12" sm="4" md="3" lg="3"
                                                    v-if="filterEquipment.CgeTypeAssigns == 2">
                                                    <s-text label="N° AnyDesk" v-model="worker.EanNumAnydesk" outlined
                                                        dense class="modern-input" />
                                                </v-col>
                                                <v-col cols="12" sm="4" md="3" lg="3"
                                                    v-if="filterEquipment.CgeTypeAssigns == 2">
                                                    <s-text label="Clave AnyDesk" v-model="worker.EanPassword" outlined
                                                        dense class="modern-input" />
                                                </v-col>
                                            </v-row>

                                            <!-- Observaciones -->
                                            <v-row dense>
                                                <v-col cols="12">
                                                    <s-textarea label="Observaciones" v-model="worker.EanObservation"
                                                        outlined dense :rows="2" class="modern-input" />
                                                </v-col>
                                            </v-row>

                                            <!-- Equipos Asignados -->
                                            <div class="equipment-section mt-3">
                                                <div class="section-header mb-2">
                                                    <v-icon class="section-icon"
                                                        color="orange">mdi-laptop-account</v-icon>
                                                    <h3 class="section-title">Equipos Asignados</h3>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="primary" icon small @click="inizializeCamera()"
                                                        class="camera-btn">
                                                        <v-icon>mdi-camera</v-icon>
                                                    </v-btn>
                                                </div>

                                                <div class="table-container">
                                                    <v-data-table :headers="headersEquipmentAssignament"
                                                        :items="filtereditemsEquipmentAssignament" dense
                                                        class="modern-table" :items-per-page="10">
                                                        <template v-slot:[`item.CgeDate`]="{ item }">
                                                            <span class="date-chip">
                                                                {{ item.CgeDate ?
                                                                    $moment(item.CgeDate).format($const.FormatDateView) : ""
                                                                }}
                                                            </span>
                                                        </template>
                                                        <template v-slot:item.CptAction="{ item }">
                                                            <v-btn x-small color="error"
                                                                @click="deleteEquipmentWorker(item)" class="action-btn">
                                                                <v-icon small>mdi-delete</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <template v-slot:item.AsgCharacteristics="{ item }">
                                                            <div style="display: flex; gap: 8px">
                                                                <v-btn x-small color="info"
                                                                    @click="AsgCharacteristics(item)"
                                                                    class="action-btn">
                                                                    <v-icon>mdi-format-list-bulleted-type</v-icon>
                                                                </v-btn>
                                                                <v-btn x-small color="success"
                                                                    @click="AsgAccessory(item)" class="action-btn">
                                                                    <v-icon>mdi-playlist-plus</v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                    </v-data-table>
                                                </div>

                                                <!-- Imagen de asignación -->
                                                <div v-if="EanPhotoAssign || EanPhotoAssignDB"
                                                    class="photo-container mt-3">
                                                    <div class="photo-card">
                                                        <img :src="EanPhotoAssign || EanPhotoAssignDB"
                                                            alt="Foto de asignación" class="assignment-photo" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </v-col>

                                <!-- Panel derecho - Equipos disponibles -->
                                <v-col cols="12" lg="6" class="">
                                    <div class="section-card" :class="{ loading: loading }">
                                        <div class="section-header">
                                            <v-icon class="section-icon" color="warning">mdi-laptop</v-icon>
                                            <h3 class="section-title">Equipos Disponibles</h3>
                                        </div>

                                        <div class="search-container mt-4 mb-4">
                                            <s-text v-model="filterEquipment.Search" label="Buscar equipos..."
                                                prepend-inner-icon="mdi-magnify" @input="searchTypeAssign()" outlined
                                                dense clearable class="search-input" />
                                        </div>

                                        <div class="table-container">
                                            <v-data-table :headers="headersEquipmentAssignament"
                                                :items="filtereditemsComponent" dense
                                                class="modern-table available-equipment-table" :loading="loading"
                                                loading-text="Cargando equipos..." :items-per-page="10">
                                                <template v-slot:[`item.CgeDate`]="{ item }">
                                                    <span class="date-chip">
                                                        {{ item.CgeDate ?
                                                            $moment(item.CgeDate).format($const.FormatDateView) : "" }}
                                                    </span>
                                                </template>
                                                <template v-slot:item.CptAction="{ item }">
                                                    <v-btn x-small color="success" @click="addEquipmentWorker(item)"
                                                        class="action-btn add-btn">
                                                        <v-icon small>mdi-plus</v-icon>
                                                    </v-btn>
                                                </template>
                                                <template v-slot:item.AsgCharacteristics="{ item }">
                                                    <div style="display: flex; gap: 8px">
                                                        <v-btn x-small color="info" @click="AsgCharacteristics(item)"
                                                            class="action-btn">
                                                            <v-icon>mdi-format-list-bulleted-type</v-icon>
                                                        </v-btn>
                                                        <v-btn x-small color="success" @click="AsgAccessory(item)"
                                                            class="action-btn">
                                                            <v-icon>mdi-playlist-plus</v-icon>
                                                        </v-btn>
                                                    </div>
                                                </template>
                                            </v-data-table>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCharacteristics" v-if="dialogCharacteristics" max-width="500px">
            <v-card>
                <v-container>
                    <s-crud :config="configCharacteristics" title="Características" searchInput
                        :filter="filterCharacteristics" close :add="$fun.isAdmin()" :edit="$fun.isAdmin()"
                        :remove="$fun.isAdmin()" @save="saveCharacteristics($event)"
                        @close="dialogCharacteristics = false" ref="scrudCharacteristics">
                        <template v-slot="props">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" class="s-col-form" md="6">
                                        <s-select-definition :def="1532" :dgr="CgeIDGroup" label="Nombre"
                                            v-model="props.item.EctCharacteristics" :add="$fun.isAdmin()" />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="6">
                                        <s-text label="Valor" uppercase v-model="props.item.EctValueCharacteristics" />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </template>
                    </s-crud>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="dialogAccessory" v-if="dialogAccessory" max-width="900px">
            <v-card class="rounded-xl">
                <div class="modern-header">
                    <div class="header-content">
                        <div class="header-left">
                            <v-icon class="header-icon" size="28" color="white">mdi-television</v-icon>
                            <h2 class="header-title" style="font-size: 1.2rem">
                                ACCESORIOS VINCULADOS
                            </h2>
                        </div>
                        <div class="header-actions">
                            <v-btn color="primary" fab small class="" @click="showAddAccessory = true, EayID = null">
                                <v-icon color="white">mdi-plus</v-icon>
                            </v-btn>
                            <v-btn icon large class="close-btn" @click="dialogAccessory = false">
                                <v-icon color="white">mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>

                <v-col cols="12" md="8" v-if="showAddAccessory">
                    <div class="d-flex align-end justify-end">
                        <div class="flex-grow-1 mr-2">
                            <s-select :clearable="true" :autocomplete="true" label="Accesorios disponibles"
                                :items="itemsAccesoryAvailables" item-text="EayAccessoryFullName" item-value="EayID"
                                placeholder="Seleccionar Accesorio" :slotTmp="true" v-model="EayID" id="EayID"
                                ref="EayID">
                                <template #item="{ item }">
                                    <div style="display:flex; flex-direction:column;width: 100%;">
                                        <div class="font-weight-medium text-uppercase text-body-2">
                                            {{ item.EayAccessoryFullName }}
                                        </div>
                                    </div>
                                </template>
                            </s-select>
                        </div>
                        <div class="header-actions">
                            <v-btn class="" fab color="primary" x-small dark elevation="2"
                                @click="saveAsignacionAccesory">
                                <v-icon color="white">mdi-content-save</v-icon>
                            </v-btn>
                            <v-btn class="" fab color="error" x-small dark elevation="2"
                                @click="showAddAccessory = false">
                                <v-icon color="white">mdi-close</v-icon>
                            </v-btn>
                        </div>

                        <!-- <v-btn class="rounded-lg" color="primary" small dark elevation="2"
                            @click="saveAsignacionAccesory">
                            VINCULAR ACCESORIO
                        </v-btn> -->
                    </div>
                </v-col>

                <v-card class="pb-4 col-12" flat>
                    <v-data-table :headers="headersAccesoryHistory" :items="itemsAccesoryHistory" dense
                        class="custom-table" item-key="EayID">
                        <template v-slot:item.EayAccessoryName="{ item }">
                            {{ item.EayAccessoryName }}
                            <template v-if="item.EayObservation">
                                <h5 class="text-caption">{{ item.EayObservation }}</h5>
                            </template>
                            <v-chip x-small color="primary" v-if="item.EayPhoneNumber" class="mt-1">Tel: {{
                                item.EayPhoneNumber
                                }}</v-chip>
                        </template>

                        <template v-slot:item.EayState="{ item }">
                            <v-chip x-small outlined :color="[1, 2].includes(item.EayState) ? 'success' : 'error'"
                                class="pa-2 rounded-xl pl-2 pr-2">
                                {{ item.EayStateName }}
                            </v-chip>
                        </template>

                        <template v-slot:item.EayOptions="{ item }">
                            <v-tooltip v-if="item.EayStatus == null" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="error" fab x-small dark elevation="2"
                                        @click="removeAsignacionAccesory(item)" v-bind="attrs" v-on="on">
                                        <v-icon>mdi-attachment-remove</v-icon>
                                    </v-btn>
                                </template>
                                <span>Liberar</span>
                            </v-tooltip>

                            <v-chip v-else x-small outlined
                                :color="[1, 2].includes(item.EayStatus) ? 'success' : 'error'"
                                class="pa-2 rounded-xl pl-2 pr-2">
                                {{ item.EayStatusDevolutionName }}
                            </v-chip>
                        </template>
                    </v-data-table>
                </v-card>

                <v-container>
                    <!-- <s-crud :config="configAccessory" title="Accesorios" :filter="filterCharacteristicsOrAccessory"
                        close add edit searchInput @save="saveAccessory($event)" @close="dialogAccessory = false"
                        ref="scrudAccessory">
                        <template v-slot="props">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" class="s-col-form" md="3">
                                        <s-select-definition :def="1543" label="Accesorio"
                                            v-model="props.item.EayAccessory" :add="$fun.isAdmin()" />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="3" v-if="!props.item.EayObservation">
                                        <s-select-definition :def="1533" label="Marca" v-model="props.item.EayBrand"
                                            :add="$fun.isAdmin()" clearable searchable />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="3" v-if="!props.item.EayObservation">
                                        <v-row dense no-gutters align="center">
                                            <v-col v-if="showAddModelInput">
                                                <v-text-field v-model="newModelName" label="Nuevo Modelo" dense hide-details autofocus
                                                    @keyup.enter="saveNewModel"
                                                    @keyup.esc="showAddModelInput = false; newModelName = ''">
                                                    <template v-slot:append>
                                                        <v-btn icon x-small color="success" @click="saveNewModel">
                                                            <v-icon>mdi-check</v-icon>
                                                        </v-btn>
                                                        <v-btn icon x-small color="error" @click="showAddModelInput = false; newModelName = ''">
                                                            <v-icon>mdi-close</v-icon>
                                                        </v-btn>
                                                    </template>
                                                </v-text-field>
                                            </v-col>
                                            <v-col v-else>
                                                <v-autocomplete :items="equipmentModels" item-text="EmdName" item-value="EmdID"
                                                    label="Modelo" v-model="props.item.EayModel" clearable hide-details />
                                            </v-col>
                                            <v-col v-if="!showAddModelInput && $fun.isAdmin()" cols="auto" class="pl-1">
                                                <v-btn icon x-small color="primary" @click="showAddModelInput = true; newModelName = ''">
                                                    <v-icon>mdi-plus-circle</v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="3" v-if="!props.item.EayObservation">
                                        <s-text :disabled="props.item.EayID ? true : false" label="Serie"
                                            v-model="props.item.EaySerie" />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="9" v-if="validatedItems(props.item)">
                                        <s-text label="Descripción" v-model="props.item.EayObservation" />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="3">
                                        <s-select-definition :def="1593" :add="$fun.isAdmin()" label="Estado"
                                            v-model="props.item.EayState" clearable />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="3">
                                        <s-date v-model="props.item.EayDate" label="Fecha Adquisición" />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </template>

                        <template v-slot:item.EayState="{ item }">
                            <v-chip v-if="item.EayState == 1 || item.EayState == 2" x-small color="success"
                                class="pa-3 rounded-xl pl-2 pr-2">
                                {{ item.EayStateName }}
                            </v-chip>
                            <v-chip v-else-if="item.EayState == 3 || item.EayState == 4" x-small color="warning"
                                class="pa-3 rounded-xl pl-2 pr-2">
                                {{ item.EayStateName }}
                            </v-chip>
                            <v-chip v-else x-small color="primary" class="pa-3 rounded-xl pl-2 pr-2">
                                {{ item.EayStateName }}
                            </v-chip>
                        </template>

                        <template v-slot:item.EayDevolution="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="error" fab x-small dark elevation="2"
                                        @click="openModalDevolution(item)" v-bind="attrs" v-on="on">
                                        <v-icon>mdi-attachment-remove</v-icon>
                                    </v-btn>
                                </template>
                                <span>Liberar</span>
                            </v-tooltip>
                        </template>
                    </s-crud> -->
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDevolution" v-if="dialogDevolution" max-width="1200px" persistent>
            <v-card class="rounded-xl">
                <div class="modern-header-modal">
                    <div class="header-content">
                        <div class="header-left">
                            <v-icon class="header-icon" size="28" color="white">mdi-sync</v-icon>
                            <h2 class="header-title" style="text-transform: uppercase;font-size: 1.2rem">
                                Devolución de Equipos
                            </h2>
                        </div>
                        <div class="header-actions">
                            <v-btn icon large class="close-btn" @click="inizializeCamera()">
                                <v-icon color="primary">mdi-camera</v-icon>
                            </v-btn>
                            <v-btn icon large class="close-btn" @click="saveDevolution()">
                                <v-icon color="white">mdi-content-save</v-icon>
                            </v-btn>
                            <v-btn icon large class="close-btn ml-4" @click="dialogDevolution = false">
                                <v-icon color="white">mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>

                <!-- <s-toolbar label=" " color="#8e8f91" save dark @save="saveDevolution()">
                    <v-tooltip bottom="">
                        <template v-slot:activator="{ on }">
                            <v-btn text v-on="on" small @click="inizializeCamera()">
                                <v-icon style="font-size: 16px">mdi-camera</v-icon></v-btn>
                        </template>
                        <span>Adjuntar foto</span>
                    </v-tooltip>
                </s-toolbar> -->

                <v-container fluid>
                    <v-row dense>
                        <v-col cols="12" md="5">
                            <s-text label="Responsable" v-model="itemsDevolutionAbsolute.NtpFullName" disabled></s-text>
                        </v-col>
                        <v-col cols="12" sm="7" md="5">
                            <s-text label="Area" v-model="itemsDevolutionAbsolute.AreName" disabled></s-text>
                        </v-col>
                        <v-col cols="12" sm="5" md="2">
                            <s-text v-model="itemsDevolutionAbsolute.EanDateFromData" label="Fecha Entrega"
                                disabled></s-text>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-data-table dense :items="itemsDevolution" :headers="headersDevolution"
                                :items-per-page="-1" item-key="EadID">

                                <template v-slot:[`item.TdtStatus`]="{ item }">
                                    <s-select-definition :disabled="item.InDevolution == 1 ? false : true" :def="1539"
                                        label=" " v-model="item.TdtStatus" />
                                </template>
                                <template v-slot:[`item.TdtObservation`]="{ item }">
                                    <s-text :disabled="item.InDevolution == 1 ? false : true"
                                        v-model="item.TdtObservation" />
                                </template>
                                <template v-slot:[`item.TdtReleaseAccesory`]="{ item }">
                                    <div v-if="showReleaseAccesory(item.EanID)"
                                        class="d-flex justify-center items-center">

                                        <v-btn class="rounded-lg" small color="success"
                                            @click="modalDevolutionAccesory(item)">
                                            <v-icon>mdi-sync</v-icon>
                                        </v-btn>

                                        <!-- <v-checkbox class="pa-0 ma-0" :disabled="item.InDevolution == 1 ? false : true"
                                            aria-hidden="false" hide-details v-model="item.TdtReleaseAccesory"
                                            true-value="1" false-value="0"></v-checkbox> -->
                                    </div>
                                </template>

                                <template v-slot:[`item.TdtStatusDevolution`]="{ item }">
                                    <div class="d-flex justify-center items-center">
                                        <v-checkbox class="pa-0 ma-0" :disabled="item.InDevolution == 1 ? false : true"
                                            v-model="item.TdtStatusDevolution" hide-details
                                            @change="item.TdTDateReplacement = null"></v-checkbox>
                                    </div>
                                </template>
                                <template v-slot:[`item.TdTDateReplacement`]="{ item }">
                                    <s-date v-if="
                                        item.TdtStatusDevolution ||
                                        (item.TdtStatusDevolution == false &&
                                            item.InDevolution == 0)
                                    " :disabled="item.InDevolution == 1 ? false : true" clearable
                                        v-model="item.TdTDateReplacement" label="" />
                                    <s-text v-else placeholder="DD/MM/YYYY" disabled></s-text>
                                </template>
                                <template v-slot:[`item.AsgNewEquipment`]="{ item }">
                                    <v-btn :disabled="item.TdtStatusDevolution == false" x-small color="success"
                                        @click="addEvent(item)"><v-icon
                                            style="font-size: 18px">mdi-plus-circle-outline</v-icon></v-btn>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <img v-if="!EanPhotoDevolution && EanPhotoDevolutionDB" :src="EanPhotoDevolutionDB"
                                alt="Foto desde BD" style="width: 300px; object-fit: cover; height: auto" />
                            <img v-if="EanPhotoDevolution" :src="EanPhotoDevolution" alt="Foto tomada"
                                style="width: 300px; object-fit: cover; height: auto" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDevolutionView" v-if="dialogDevolutionView" max-width="1200px" persistent>
            <v-card class="rounded-xl">
                <div class="modern-header-modal">
                    <div class="header-content">
                        <div class="header-left">
                            <v-icon class="header-icon" size="28" color="white">mdi-sync</v-icon>
                            <h2 class="header-title" style="text-transform: uppercase;font-size: 1.2rem">
                                Devolución de Equipos
                            </h2>
                        </div>
                        <div class="header-actions">
                            <v-btn icon large class="close-btn" @click="dialogDevolutionView = false">
                                <v-icon color="white">mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>

                <!-- <s-toolbar label=" " color="#8e8f91" dark close @close="dialogDevolutionView = false"></s-toolbar> -->
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="12" md="5">
                            <s-text label="Responsable" v-model="itemsDevolutionAbsolute.NtpFullName" disabled></s-text>
                        </v-col>
                        <v-col cols="12" sm="7" md="5">
                            <s-text label="Area" v-model="itemsDevolutionAbsolute.AreName" disabled></s-text>
                        </v-col>
                        <v-col cols="12" sm="5" md="2">
                            <s-text v-model="itemsDevolutionAbsolute.EanDateFromData" label="Fecha Entrega"
                                disabled></s-text>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-data-table dense :items="itemsDevolution" :headers="headersDevolution"
                                :items-per-page="-1" item-key="EadID">
                                <template v-slot:[`item.TdtStatus`]="{ item }">
                                    <s-select-definition :disabled="item.InDevolution == 1 ? false : true" :def="1539"
                                        v-model="item.TdtStatus" label=" " />
                                </template>
                                <template v-slot:[`item.TdtObservation`]="{ item }">
                                    <s-text :disabled="item.InDevolution == 1 ? false : true"
                                        v-model="item.TdtObservation" />
                                </template>

                                <template v-slot:[`item.TdtReleaseAccesory`]="{ item }">
                                    <!-- <v-chip x-small :color="item.TdtReleaseAccesory == 1 ? 'success' : 'primary'"
                                        class="pa-3 rounded-xl pl-2 pr-2">
                                        {{ item.TdtReleaseAccesory == 1 ? 'Liberados' : 'Manual' }}
                                    </v-chip> -->
                                </template>

                                <template v-slot:[`item.TdtStatusDevolution`]="{ item }">
                                    <div class="d-flex justify-center items-center">
                                        <v-checkbox class="pa-0 ma-0" :disabled="item.InDevolution == 1 ? false : true"
                                            label="" hide-details v-model="item.TdtStatusDevolution"
                                            @change="item.TdTDateReplacement = null"></v-checkbox>
                                    </div>
                                </template>

                                <template v-slot:[`item.TdTDateReplacement`]="{ item }">
                                    <s-date v-if="
                                        item.TdtStatusDevolution ||
                                        (item.TdtStatusDevolution == false &&
                                            item.InDevolution == 0)
                                    " :disabled="item.InDevolution == 1 ? false : true" clearable
                                        v-model="item.TdTDateReplacement" label="" />
                                    <s-text v-else placeholder="DD/MM/YYYY" disabled></s-text>
                                </template>
                                <template v-slot:[`item.AsgNewEquipment`]="{ item }">
                                    <v-btn :disabled="item.TdtStatusDevolution == false" x-small color="success"
                                        @click="addEvent(item)"><v-icon
                                            style="font-size: 18px">mdi-plus-circle-outline</v-icon></v-btn>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <img v-if="!EanPhotoDevolution && EanPhotoDevolutionDB" :src="EanPhotoDevolutionDB"
                                alt="Foto desde BD" style="width: 300px; object-fit: cover; height: auto" />
                            <img v-if="EanPhotoDevolution" :src="EanPhotoDevolution" alt="Foto tomada"
                                style="width: 300px; object-fit: cover; height: auto" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogReplacement" v-if="dialogReplacement" max-width="900px" persistent>
            <v-card dense>
                <s-toolbar label="Nuevo Equipo" color="#8e8f91" dark close @save="saveReplacement()" save
                    @close="dialogReplacement = false"></s-toolbar>
                <v-container>
                    <v-row>
                        <v-col cols="12" class="s-col-form" md="3">
                            <s-select-definition :def="1530" label="Equipo" v-model="itemReplacement.CgeTypeEquipment"
                                disabled />
                        </v-col>
                        <v-col cols="12" class="s-col-form" md="3">
                            <s-select-definition :def="1531" label="Tipo Asignación"
                                v-model="itemReplacement.CgeTypeAssigns" disabled />
                        </v-col>
                        <v-col cols="12" class="s-col-form" md="3">
                            <s-select-definition :def="1533" label="Marca" v-model="itemReplacement.CgeBrand"
                                :add="$fun.isAdmin()" />
                        </v-col>
                        <v-col cols="12" class="s-col-form" md="3">
                            <v-row dense no-gutters align="center">
                                <v-col v-if="showAddModelInput">
                                    <v-text-field v-model="newModelName" label="Nuevo Modelo" dense hide-details
                                        autofocus @keyup.enter="saveNewModel"
                                        @keyup.esc="showAddModelInput = false; newModelName = ''">
                                        <template v-slot:append>
                                            <v-btn icon x-small color="success" @click="saveNewModel">
                                                <v-icon>mdi-check</v-icon>
                                            </v-btn>
                                            <v-btn icon x-small color="error"
                                                @click="showAddModelInput = false; newModelName = ''">
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col v-else>
                                    <v-autocomplete :items="equipmentModels" item-text="EmdName" item-value="EmdID"
                                        label="Modelo" v-model="itemReplacement.CgeModel" clearable hide-details />
                                </v-col>
                                <v-col v-if="!showAddModelInput && $fun.isAdmin()" cols="auto" class="pl-1">
                                    <v-btn icon x-small color="primary"
                                        @click="showAddModelInput = true; newModelName = ''">
                                        <v-icon>mdi-plus-circle</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: 5px !important">
                        <v-col cols="12" class="s-col-form" md="3">
                            <s-text label="Serie" v-model="itemReplacement.CgeSerie" />
                        </v-col>
                        <v-col cols="12" class="s-col-form" md="3">
                            <s-date v-model="itemReplacement.CgeDate" label="Fecha Adquisición" />
                        </v-col>
                        <v-col cols="12" class="s-col-form" md="2" v-show="false">
                            <v-switch label="Asignable" v-model="itemReplacement.CgeAssigns" dense hide-details />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-if="dialogPdfDevolution" v-model="dialogPdfDevolution" fullscreen persistent>
            <PdfDevolution :item="dataPdf" @close="dialogPdfDevolution = false"></PdfDevolution>
        </v-dialog>

        <v-dialog v-if="dialogPdfAsignation" v-model="dialogPdfAsignation" fullscreen persistent>
            <PdfAsignation :item="dataPdf" @close="dialogPdfAsignation = false"></PdfAsignation>
        </v-dialog>

        <v-dialog v-model="dialogCamera" v-if="dialogCamera" max-width="600px">
            <v-card>
                <s-camera-sun-expert @photo-confirmed="handlePhotoConfirmed" />
                <!-- <s-toolbar label="Capturar Foto" dark color="#8e8f91" close @close="stopCamera()"></s-toolbar>
				<v-container>
					<v-row>
						<v-col>
							<video style="max-width: 100%; height: auto; object-fit: cover;" ref="video" v-show="dialogCamera" autoplay></video>
							<canvas ref="canvas" style="display: none;"></canvas>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-btn color="success" block @click="captureImage()" v-if="dialogCamera">Tomar Foto</v-btn>
						</v-col>
					</v-row>
				</v-container> -->
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogAccesoryDevolution" v-if="dialogAccesoryDevolution" max-width="900px" persistent>
            <v-card class="rounded-xl">
                <div class="modern-header-modal">
                    <div class="header-content">
                        <div class="header-left">
                            <v-icon class="header-icon" size="28" color="white">mdi-sync</v-icon>
                            <h2 class="header-title" style="text-transform: uppercase;font-size: 1.2rem">
                                Devolución de Accesorios
                            </h2>
                        </div>
                        <div class="header-actions">
                            <v-btn icon large class="close-btn" @click="dialogAccesoryDevolution = false">
                                <v-icon color="white">mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>

                <v-col>
                    <v-data-table dense :items="getAccesoriesDevolution" :headers="headersAccesoryDevolution"
                        :items-per-page="-1" item-key="AahcID">
                        <template v-slot:item.EayAccionsCheckboxDevolution="{ item }">
                            <div class="d-flex justify-center align-center pa-0 ma-0"
                                v-if="item.DateDevolution == null">
                                <v-checkbox v-model="selectedAccessoryCheckIds" @change="changeCheckbox($event)"
                                    class="ma-0 pa-0" :value="item.EayID" hide-details>
                                </v-checkbox>
                            </div>
                        </template>
                        <template v-slot:item.EayStateDevolution="{ item }">
                            <s-select-definition :def="1593" :add="$fun.isAdmin()" label=" "
                                v-model="item.EayStateDevolution" />
                        </template>
                        <template v-slot:item.AahObservation="{ item }">
                            <s-textarea label=" " v-model="item.AahObservation" :rows="1" />
                        </template>
                    </v-data-table>
                </v-col>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="dialogUnassignament" v-if="dialogUnassignament" max-width="400px">
            <v-card class="rounded-xl">
                <div class="modern-header">
                    <div class="header-content">
                        <div class="header-left">
                            <v-icon class="header-icon" size="28" color="white">mdi-link-off</v-icon>
                            <h2 class="header-title" style="text-transform: uppercase;font-size: 1.2rem">
                                Devolución de Accesorio
                            </h2>
                        </div>
                        <div class="header-actions">
                            <v-btn icon large class="close-btn" @click="dialogUnassignament = false">
                                <v-icon color="white">mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>

                <v-col>
                    <v-row>
                        <v-col cols="12" class="s-col-form">
                            <s-select-definition :def="1593" :add="$fun.isAdmin()" label="Estado Devolución" clearable
                                v-model="formAccDevolution.EayStateDevolution" />
                        </v-col>
                        <v-col cols="12">
                            <s-textarea label="Observación" v-model="formAccDevolution.AahObservation" :rows="1" />
                        </v-col>
                    </v-row>
                    <v-row justify="end" align="center">
                        <v-card-actions>
                            <v-btn class="rounded-lg" color="primary"
                                @click="saveDevolutionAccessory">Desvincular</v-btn>
                        </v-card-actions>
                    </v-row>
                </v-col>
            </v-card>
        </v-dialog>


        <!-- Floating Alert Widget -->
        <v-slide-y-reverse-transition>
            <v-card v-if="dialogExpiredContracts" class="floating-alert-card rounded-xl elevation-10">
                <div class="header-content error white--text pa-2 d-flex align-center justify-space-between pointer"
                    @click="isAlertExpanded = !isAlertExpanded">
                    <div class="header-left d-flex align-center">
                        <v-icon class="header-icon mr-2" size="24" color="white">mdi-alert-circle</v-icon>
                        <h3 class="white--text text-subtitle-1 font-weight-bold mb-0">
                            Evaluación Pendiente ({{ expiredContractsList.length }})
                        </h3>
                    </div>
                    <div class="header-actions">
                        <v-btn icon small class="close-btn" @click.stop="isAlertExpanded = !isAlertExpanded">
                            <v-icon color="white">
                                {{ isAlertExpanded ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
                            </v-icon>
                        </v-btn>
                        <v-btn icon small class="close-btn ml-1" @click.stop="dialogExpiredContracts = false">
                            <v-icon color="white">mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>

                <v-expand-transition>
                    <div v-show="isAlertExpanded" class="alert-content">
                        <v-list dense class="pa-0">
                            <v-list-item-group color="primary">
                                <v-list-item v-for="(item, index) in expiredContractsList" :key="index"
                                    class="pa-2 selectable-text" style="border-bottom: 1px solid #eee;">
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-medium text-caption text-wrap">
                                            <span style="font-weight: bold;">{{ item.PrsDocumentNumber }}</span>
                                            {{ item.NtpFullName }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle class="text-caption grey--text">
                                            {{ item.AreName }} - {{ item.PstName }}
                                        </v-list-item-subtitle>
                                        <div class="d-flex align-center mt-1">
                                            <v-chip color="error" x-small outlined class="mr-2">
                                                {{ item.CtrStatusName }}
                                            </v-chip>
                                            <span class="text-caption error--text">
                                                {{ $fun.formatDateView(item.CtrTerminationDate) }}
                                            </span>
                                        </div>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </div>
                </v-expand-transition>
            </v-card>
        </v-slide-y-reverse-transition>
    </v-card>
</template>

<script>
import EquimentAssignamentNew from "../../../services/InformationTechnology/EquimentAssignamentNew";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import TicEquipmentService from "../../../services/InformationTechnology/TicEquipmentService";
import TicEquipmentCharacteristic from "@/services/InformationTechnology/EquimentCharacteristicService";
import _serviceAccesorio from "@/services/InformationTechnology/EquimentAccessoryService";
import PdfDevolution from "./PdfDevolution.vue";
import PdfAsignation from "./PdfAsignation.vue";
import GenUploadFiles from "../../../services/General/GenUploadFiles";
import EquipmentModelService from "../../../services/InformationTechnology/EquipmentModelService";

export default {
    components: {
        sToolbarPerson,
        PdfDevolution,
        PdfAsignation,
    },
    data() {
        return {
            formDevolution: {},
            equipmentModels: [],
            showAddModelInput: false,
            newModelName: '',
            dialogExpiredContracts: false,
            isAlertExpanded: false,
            expiredContractsList: [],
            headersExpiredContracts: [
                { text: "DNI", value: "PrsDocumentNumber", sortable: false, width: 150, class: "pa-2" },
                { text: "Nombre", value: "NtpFullName", sortable: false, class: "pa-2" },
                { text: "Area", value: "AreName", sortable: false, align: "center", class: "pa-2" },
                { text: "Cargo", value: "PstName", sortable: false, class: "pa-2" },
                { text: "Fecha Cese", value: "CtrTerminationDate", align: "center", sortable: false, width: 120, class: "pa-2" },
                { text: "Estado", value: "CtrStatusName", sortable: false, align: "center", width: 120, class: "pa-2" },
            ],
            dialogUnassignament: false,
            isPhotoAssign: true,
            EanPhotoAssign: null,
            EanPhotoDevolution: null,
            EanPhotoAssignDB: null,
            EanPhotoDevolutionDB: null,
            dialogCamera: false,
            stream: null,
            dialogPdfDevolution: false,
            dialogPdfAsignation: false,
            dataPdf: {},
            totalDevolution: false,
            dialogReplacement: false,
            itemReplacement: {},
            itemsDevolutionAbsolute: {},
            itemsDevolution: [],
            dialogDevolution: false,
            dialogDevolutionView: false,
            showAddAccessory: false,
            dialogAccessory: false,
            filterCharacteristicsOrAccessory: {
                CgeID: "",
            },
            headersDevolution: [
                { text: "Equipo", value: "CgeTypeEquipmentName", width: 160, sortable: false },
                { text: "Serie", value: "CgeSerie", width: 100, align: "center", sortable: false },
                { text: "Estado del Equipo", value: "TdtStatus", width: 140, align: "center", sortable: false },
                { text: "Observaciones", value: "TdtObservation", sortable: false },
                { text: "¿Liberar Accesorios?", value: "TdtReleaseAccesory", align: "center", width: 50, sortable: false },
                { text: "¿Reponer?", value: "TdtStatusDevolution", align: "center", width: 50, sortable: false },
                { text: "Dia Reposición", value: "TdTDateReplacement", align: "center", width: 120, sortable: false },
                { text: "Equipo Nuevo", value: "AsgNewEquipment", width: 110, align: "center", sortable: false },
            ],
            CtrEndDate: null,
            searchAre: true,
            CgeIDGroup: 0,
            dialogCharacteristics: false,
            filterCharacteristics: {
                CgeID: "",
            },
            configCharacteristics: {
                service: TicEquipmentCharacteristic,
                model: {
                    EctID: "ID",
                    EctDate: "date",
                },
                headers: [
                    { text: "Nombre", value: "EctCharacteristicsName" },
                    { text: "Valor", value: "EctValueCharacteristics" },
                ],
            },
            loading: false,
            itemsEquipmentAssignament: [],
            worker: {
                EanID: "",
                NtpID: "",
                NtpFullName: "",
                PrsDocumentNumber: "",
                EanNumAnydesk: "",
                EanPassword: "",
                EanHostName: "",
                EanObservation: "",
                EanDateFrom: this.$fun.getDate(""),
                EanDateUntil: "",
                EanArea: "",
                EanZone: "",
                UsrCreateID: "",
                EanTypeAssigns: "",
                ItemsDetail: [],
            },
            itemsComponent: [],
            dialogAssignment: false,
            headersEquipmentAssignament: [
                { text: "ID", value: "CgeID" },
                { text: "Equipo", value: "CgeTypeEquipmentName" },
                { text: "Marca", value: "CgeBrandName" },
                { text: "Modelo", value: "CgeModelName" },
                { text: "Serie", value: "CgeSerie", align: "center" },
                { text: "Hostname", value: "CgeHostname", align: "center" },
                { text: "AnyDesk", value: "CgeAnydesk", align: "center" },
                { text: "Fecha de Adquisicion", value: "CgeDate", align: "center" },
                { text: "Acción", value: "CptAction", width: 50, align: "center" },
                { text: "Visualizar", value: "AsgCharacteristics", width: 50, align: "center" },
            ],
            filterEquipment: {
                CgeTypeAssigns: "",
                Search: "",
            },
            filter: {
                EanDateFrom: "",
                EanDateUntil: "",
                AreID: "",
                CgeTypeAssigns: "",
                EanZone: "",
                EanStatus: 0,
            },
            config: {
                model: {
                    EanID: "ID",
                    AsgAction: "",
                    EanDateFrom: "date",
                    EanDateUntil: "date",
                    AsgDevolution: "",
                    AsgSecStatus: "",
                },
                service: EquimentAssignamentNew,
                headers: [
                    { text: "ID", value: "EanID", draggable: false },
                    { text: "Tipo Asignación", value: "CgeTypeAssignsName", width: 60, align: "center", draggable: false },
                    { text: "Devolución", value: "AsgDevolution", width: 60, align: "center", draggable: false },
                    { text: "Area", value: "AreName" },
                    { text: "DNI", value: "PrsDocumentNumber", width: 80 },
                    { text: "Apellidos y Nombres", value: "NtpFullName" },
                    { text: "Zona", value: "EanZoneName" },
                    { text: "Fecha Inicio", value: "EanDateFrom" },
                    { text: "Fecha Fin", value: "EanDateUntil" },
                    { text: "Estado Asignación", value: "AsgSecStatus", width: 80, draggable: false },
                    { text: "Contrato", value: "CtrStatusName", width: 70, draggable: false },
                    { text: "Editar", value: "AsgAction", width: 50, align: "center", draggable: false },
                ],
            },
            itemSelected: {},
            configAccessory: {
                service: _serviceAccesorio,
                model: {
                    EayID: "ID",
                    EayDevolution: "",
                },
                headers: [
                    { text: "Nombre", value: "EayAccessoryName" },
                    { text: "Marca", value: "EayBrandName", width: 120 },
                    { text: "Modelo", value: "EayModelName", width: 120 },
                    { text: "Serie", value: "EaySerie", align: "center" },
                    { text: "Estado", value: "EayState", width: 70, align: "center" },
                    { text: "Observación", value: "EayObservation" },
                    { text: "Devolución", value: "EayDevolution", width: 70, align: "center" },
                ],
            },
            dialogAccesoryDevolution: false,
            EadID: null,
            accesoriesDevolution: [],
            // itemsAccesoryDevolution: [],
            headersAccesoryDevolution: [
                { text: "Liberar", value: "EayAccionsCheckboxDevolution" },
                { text: "ID", value: "AahcID" },
                { text: "Nombre", value: "EayAccessoryName" },
                { text: "Marca", value: "EayBrandName", width: 120 },
                { text: "Modelo", value: "EayModelName", width: 120 },
                { text: "Serie", value: "EaySerie", align: "center" },
                { text: "Estado Devolucion", value: "EayStateDevolution", width: 70, align: "center" },
                { text: "Observación", value: "AahObservation" },
            ],
            workDetail: {},
            EayID: null,
            formAccDevolution: {},
            itemsAccesoryAvailables: [],
            itemsAccesoryHistory: [],
            headersAccesoryHistory: [
                { text: "ID", value: "EayID", sortable: false, width: "40" },
                { text: "Nombre", value: "EayAccessoryName", sortable: false },
                { text: "Marca", value: "EayBrandName", width: 120, sortable: false },
                { text: "Modelo", value: "EayModelName", width: 120, sortable: false },
                { text: "Serie", value: "EaySerie", width: 120, sortable: false },
                { text: "Estado", value: "EayState", width: 70, align: "center", sortable: false },
                { text: "Liberar", value: "EayOptions", width: "70", align: "center", sortable: false },
            ],
            selectedAccessoryCheckIds: [],
        };
    },
    methods: {
        getStatusColor(status) {
            switch (status) {
                case 'ACTIVO':
                    return 'success'
                case 'FINALIZADO':
                    return 'primary'
                case 'CESADO':
                    return 'error'
                case 'VENCE PRONTO':
                    return 'warning'
                default:
                    return 'grey'
            }
        },
        changeCheckbox(event) {
        },
        rowSelected(item) {
            if (item !== null) {
                this.itemSelected = item[0];
            } else {
                this.itemSelected = {};
            }
        },
        openModalDevolution(accesory) {
            this.formDevolution = { ...accesory, EayStateDevolution: 0, AahObservation: '' };
            this.dialogUnassignament = true;
        },
        removeAsignacion() {
            if (!this.formDevolution.EayStateDevolution > 0) {
                this.$fun.alert("Debe seleccionar un estado de devolución", "info");
                return;
            }
            // if (!this.form.AahObservation.trim() == '') {
            // 	this.$fun.alert("Debe ingresar una observación", "error");
            // 	return;
            // }
            // console.log(this.form)
            const mensaje = "Remover Accesorio del equipo asignado ?";
            this.$fun.alert(mensaje, "question").then((res) => {
                if (res.value) {
                    // this.formDevolution.CgeID = null
                    this.formDevolution.UsrCreateID = this.$fun.getUserID();
                    this.formDevolution.EaySerie = (this.formDevolution.EaySerie == null || this.formDevolution.EaySerie == '') ? null : this.formDevolution.EaySerie.trim().toUpperCase();
                    // console.log(this.formDevolution)
                    // this.save(mensaje)
                    _serviceAccesorio.save(this.formDevolution, this.$fun.getUserID()).then((response) => {
                        this.dialogUnassignament = false;
                        if (response.status == 200) {
                            this.$refs.scrudAccessory.refresh();
                            this.$fun.alert("Accesorio liberado correctamente", "success");
                        }
                    });
                }
            })
        },
        saveReplacement() {
            this.itemReplacement.UsrCreateID = this.$fun.getUserID();
            this.itemReplacement.CgeAssigns = this.itemReplacement.CgeAssigns ? 1 : 0;
            this.itemReplacement.CgeSerie = this.$fun.trimFull(
                this.itemReplacement.CgeSerie,
                true
            );
            this.itemReplacement.CgeStatus = 1;
            if (
                this.itemReplacement.CgeModel == "" ||
                this.itemReplacement.CgeSerie.trim() == ""
            ) {
                this.$fun.alert("Debe de llenar todos los campos", "warning");
                return;
            }
            this.$fun.alertFull("¿Seguro de guardar?", "question").then(async (r) => {
                if (r.value) {
                    await TicEquipmentService.save(this.itemReplacement, this.$fun.getUserID()).then(async (r) => {
                        if (r.status == 200) {
                            this.$fun.alert("Se ha guardado correctamente", "success");
                            this.dialogReplacement = false;
                            await this.searchItemsDevolution();
                        }
                    });
                }
            });
        },
        addEvent(item) {
            this.itemReplacement = {};

            let data = this.itemsDevolutionAbsolute.ItemsDetail.find(
                (i) => i.EanID == item.EanID && i.CgeID == item.CgeID
            );

            this.itemReplacement.CgeAssigns = true;
            this.itemReplacement.CgeTypeAssigns = parseInt(data.CgeTypeAssigns);
            this.itemReplacement.CgeTypeEquipment = parseInt(data.CgeTypeEquipment);
            this.itemReplacement.CgeBrand = parseInt(data.CgeBrand);
            this.itemReplacement.CgeModel = parseInt(data.CgeModel);
            this.itemReplacement.TdtID = item.TdtID;
            this.itemReplacement.CgeIDAnt = data.CgeID;

            this.dialogReplacement = true;
        },
        async saveDevolution() {
            this.$fun.alertFull("¿Seguro de guardar?", "question").then(async (r) => {
                if (r.value) {
                    const UsrCreateID = this.$fun.getUserID();
                    const accesoriesDevolution = this.accesoriesDevolution.flatMap(x =>
                        x.ItemsAccessory.map(item => ({ ...item, EanID: x.EanID, EadID: x.EadID }))
                    ).filter(x => x.DateDevolution == null).map(x => {
                        return {
                            ...x,
                            EayStatus: this.selectedAccessoryCheckIds.includes(x.EayID) ? x.EayStateDevolution : null,
                            AahObservation: this.selectedAccessoryCheckIds.includes(x.EayID) ? x.AahObservation : null,
                            DateDevolution: this.selectedAccessoryCheckIds.includes(x.EayID) ? new Date() : null,
                            SecStatus: 1,
                            UsrCreateID
                        }
                    });

                    // console.log(accesoriesDevolution);
                    const messageResult = "Accesorios liberados correctamente";
                    this.saveOrUpdateHistoryAccesory(accesoriesDevolution, messageResult, () => { }, false);

                    for (let i = 0; i < this.itemsDevolution.length; i++) {
                        this.itemsDevolution[i].TdtStatusDevolution =
                            this.itemsDevolution[i].TdtStatusDevolution === true ||
                                this.itemsDevolution[i].TdtStatusDevolution === false
                                ? this.itemsDevolution[i].TdtStatusDevolution
                                    ? 1
                                    : 0
                                : 0;
                        if (!this.itemsDevolution[i].TdtID && !this.totalDevolution) {
                            this.totalDevolution = false;
                            let total = this.itemsDevolution.length;
                            let countDevolution = 0;
                            for (let e = 0; e < this.itemsDevolution.length; e++) {
                                if (!this.itemsDevolution[e].TdtStatusDevolution)
                                    countDevolution++;
                            }
                            if (countDevolution == total) this.totalDevolution = true;
                        }
                        if (this.totalDevolution) {
                            this.itemsDevolution[i].TdtDevolutionComplete = 1;
                        }

                        // Update the local assignment detail status to devolved (0)
                        // to prevent EquimentAssignamentNew.save from overwriting it back to 1 in the database.
                        const detail = this.itemsDevolutionAbsolute.ItemsDetail.find(
                            (d) => d.CgeID === this.itemsDevolution[i].CgeID
                        );
                        if (detail) {
                            detail.EadStatus = 0;
                        }

                        await EquimentAssignamentNew.saveDevolution(this.itemsDevolution[i], this.$fun.getUserID()).then((resp) => {
                            if (resp.status == 200) {
                            }
                        });
                    }

                    if (this.totalDevolution) {
                        this.itemsDevolutionAbsolute.EanStatus = 0;
                    }

                    // Explicitly set the technician and the date of devolution
                    this.itemsDevolutionAbsolute.UsrDevolutionID = UsrCreateID;
                    this.itemsDevolutionAbsolute.EanDateDevolution = new Date();

                    if (this.EanPhotoDevolution) {
                        try {
                            const respImg = await GenUploadFiles.upload(
                                this.EanPhotoDevolution,
                                `EanPhotoDevolution_${this.itemsDevolutionAbsolute.EanID}`,
                                "routePrueba",
                                true
                            );

                            this.itemsDevolutionAbsolute.EanPhotoDevolution =
                                respImg.data.fileName;
                        } catch (error) {
                            this.$fun.alert("Error al subir la foto", "warning");
                            console.error("Error al subir la foto", error);
                        }
                    }

                    // Always save the assignment record to persist the devolution metadata
                    await EquimentAssignamentNew.save(
                        this.itemsDevolutionAbsolute,
                        this.$fun.getUserID()
                    );

                    this.openDialogPDF(this.itemsDevolutionAbsolute, true);

                    this.$fun.alert("Se ha guardado la devolución", "success");
                    this.$refs.scrudEquipmentAssignament.refresh();
                    this.dialogDevolution = false;
                }
            });
        },
        async AsgDevolution(row) {
            await this.clear();
            await EquimentAssignamentNew.list(row.EanID, 0, this.$fun.getUserID()).then(
                (resp) => {
                    if (resp.status == 200) {
                        this.itemsDevolutionAbsolute = resp.data;
                        this.accesoriesDevolution = resp.data.ItemsDetail.map(x => ({
                            ...x,
                            ItemsAccessory: x.ItemsAccessory.map(y => ({
                                ...y,
                                EayStateDevolution: y.EayState,
                                AahObservation: null
                            }))
                        }));
                    }
                }
            );
            await this.searchItemsDevolution();
            this.itemsDevolutionAbsolute.EanDateFromData = this.$fun.formatDateView(
                this.itemsDevolutionAbsolute.EanDateFrom
            );
            this.dialogDevolution = true;
            this.isPhotoAssign = false;
            this.getphotoBD();
        },
        async AsgDevolutionView(row) {
            await EquimentAssignamentNew.list(row.EanID, 0, this.$fun.getUserID()).then(
                (resp) => {
                    if (resp.status == 200) {
                        this.itemsDevolutionAbsolute = resp.data;
                    }
                }
            );
            await this.searchItemsDevolution();
            this.itemsDevolutionAbsolute.EanDateFromData = this.$fun.formatDateView(
                this.itemsDevolutionAbsolute.EanDateFrom
            );
            this.dialogDevolutionView = true;
            this.getphotoBD();
        },
        async searchItemsDevolution() {
            this.totalDevolution = false;
            let total = 0;
            let countDevolution = 0;

            await EquimentAssignamentNew.listDevolution(
                this.itemsDevolutionAbsolute.EanID,
                this.$fun.getUserID()
            ).then((resp) => {
                if (resp.status == 200) {
                    total = resp.data.length;
                    for (let i = 0; i < resp.data.length; i++) {
                        resp.data[i].TdtStatusDevolution = resp.data[i].TdtStatusDevolution ? true : false;
                        resp.data[i].TdtReleaseAccesory = 0;
                        if (!resp.data[i].InDevolution) countDevolution++;
                    }
                    this.itemsDevolution = resp.data;
                }
            });
            if (countDevolution == total) this.totalDevolution = true;
        },
        searchDateEnd() {
            const invalidDate = new Date(1900, 0, 1);

            if (
                !this.CtrEndDate ||
                new Date(this.CtrEndDate).getTime() === invalidDate.getTime()
            ) {
                this.worker.EanDateUntil = null;
                this.$fun.alert("Esta persona tiene fecha indefinida", "warning");
            } else {
                this.worker.EanDateUntil = this.CtrEndDate;
            }
        },
        async saveDialog() {
            if (
                this.filterEquipment.CgeTypeAssigns == 1 ||
                this.filterEquipment.CgeTypeAssigns == 2
            ) {
                if (this.worker.EanArea == "" || this.worker.EanArea == null) {
                    this.$fun.alert("Seleccione una area", "warning");
                    return;
                }
            }
            if (this.worker.EanUserName == "" || this.worker.EanUserName == null) {
                this.$fun.alert("Ingrese Nombre de Usuario", "warning");
                return;
            }

            if (this.worker.EanHostName == "" || this.worker.EanHostName == null) {
                this.$fun.alert("Ingrese HostName", "warning");
                return;
            }
            if (this.itemsEquipmentAssignament.length == 0) {
                this.$fun.alert("Seleccione al menos un equipo", "warning");
                return;
            }

            for (let i = 0; i < this.itemsEquipmentAssignament.length; i++) {
                this.itemsEquipmentAssignament[i].UsrCreateID = this.$fun.getUserID();
            }

            this.worker.EanTypeAssigns = this.filterEquipment.CgeTypeAssigns;
            this.worker.UsrCreateID = this.$fun.getUserID();
            this.worker.ItemsDetail = this.itemsEquipmentAssignament;

            this.$fun.alert("¿Seguro de guardar?", "question").then(async (r) => {
                if (r.value) {
                    // console.log("this.worker", this.worker);
                    const resp = await EquimentAssignamentNew.save(this.worker, this.$fun.getUserID());
                    this.dialogAssignment = false;
                    if (this.EanPhotoAssign) {
                        try {
                            // console.log("this.EanPhotoAssign", this.EanPhotoAssign);
                            const respImg = await GenUploadFiles.upload(
                                this.EanPhotoAssign,
                                `EanPhotoAssign_${resp.data.EanID}`,
                                "routePrueba",
                                true
                            );

                            this.worker.EanPhotoAssign = respImg.data.fileName;
                            this.worker.EanID = resp.data.EanID;
                            await EquimentAssignamentNew.save(this.worker, this.$fun.getUserID());
                        } catch (error) {
                            // this.$fun.alert("Error al subir la foto", "warning");
                            // console.error("Error al subir la foto", error);
                        }
                    }

                    const ItemsDetail = resp.data?.ItemsDetail ? resp.data?.ItemsDetail : [];
                    let arrayAccesoriesDevolution = [];

                    for (let i = 0; i < ItemsDetail.length; i++) {
                        const resultlist = await _serviceAccesorio.listDevicesHistory({ CgeID: ItemsDetail[i].CgeID, OnlyAsigned: 1 }, this.$fun.getUserID())
                        let itemsAccesoryHistory = resultlist.status == 200 ? resultlist.data : [];
                        const mappedItems = itemsAccesoryHistory
                            .filter(x => x.DateDevolution == null)
                            .map(x => ({
                                AahcID: x.AahcID,
                                EayID: x.EayID,
                                CgeID: x.CgeID,
                                EanID: ItemsDetail[i].EanID,
                                EadID: ItemsDetail[i].EadID,
                                EayStatus: null,
                                AahObservation: null,
                                DateDevolution: null,
                                SecStatus: 1,
                                UsrCreateID: this.$fun.getUserID()
                            }));
                        arrayAccesoriesDevolution.push(...mappedItems);
                    }
                    // console.log(arrayAccesoriesDevolution);
                    const messageResult = "Se ha guardado correctamente";
                    this.saveOrUpdateHistoryAccesory(arrayAccesoriesDevolution, messageResult, () => {
                        this.openDialogPDF(resp.data);
                        // this.$fun.alert("Se ha guardado correctamente", "success");
                        this.$refs.scrudEquipmentAssignament.refresh();
                    }, false);
                }
            });
        },
        async openDialogPDF(item, devolution = false) {
            await EquimentAssignamentNew.list(item.EanID, Number(devolution), this.$fun.getUserID()).then(
                (resp) => {
                    if (resp.status == 200) {
                        this.dataPdf = resp.data;
                    }
                }
            );
            if (devolution) {
                this.dialogPdfDevolution = true;
            } else {
                this.dialogPdfAsignation = true;
            }
        },
        async addAssignment() {
            await this.changeTypeAssign();
            this.clear();
            // this.filterEquipment.CgeTypeAssigns = 2;
            this.dialogAssignment = true;
        },
        clear(question = false) {
            if (question) {
                this.$fun.alert("¿Seguro de limpiar?", "question").then((r) => {
                    if (r.value) {
                        this.worker = {
                            EanID: "",
                            NtpID: "",
                            NtpFullName: "",
                            PrsDocumentNumber: "",
                            EanNumAnydesk: "",
                            EanPassword: "",
                            EanUserName: "",
                            EanHostName: "",
                            EanObservation: "",
                            EanDateFrom: this.$fun.getDate(""),
                            EanDateUntil: "",
                            EanArea: "",
                            EanZone: "",
                            EanTypeAssigns: "",
                            ItemsDetail: [],
                        };
                        this.itemsEquipmentAssignament = [];
                        this.EanPhotoAssign = null;
                        this.EanPhotoAssignDB = null;
                        this.isPhotoAssign = true;
                        this.EanPhotoDevolution = null;
                        this.EanPhotoDevolutionDB = null;
                    }
                });
            } else {
                this.worker = {
                    EanID: "",
                    NtpID: "",
                    NtpFullName: "",
                    PrsDocumentNumber: "",
                    EanNumAnydesk: "",
                    EanPassword: "",
                    EanHostName: "",
                    EanObservation: "",
                    EanDateFrom: this.$fun.getDate(""),
                    EanDateUntil: "",
                    EanArea: "",
                    EanZone: "",
                    EanTypeAssigns: "",
                    ItemsDetail: [],
                };
                this.itemsEquipmentAssignament = [];
                this.EanPhotoAssign = null;
                this.EanPhotoAssignDB = null;
                this.isPhotoAssign = true;
                this.EanPhotoDevolution = null;
                this.EanPhotoDevolutionDB = null;
            }
        },
        returnPerson(data) {
            if (!data) {
                this.worker.NtpFullName = "";
                this.worker.NtpID = "";
                this.worker.EanArea = "";
                this.worker.AreName = "";
                this.CtrEndDate = "";
                this.worker.EanDateUntil = "";
            } else {
                this.worker.NtpFullName = data.NtpFullName;
                this.worker.NtpID = data.NtpID;
                this.worker.EanArea = data.AreID;
                this.worker.AreName = data.AreName;
                this.CtrEndDate = data.CtrEndDate;
                this.searchAre = false;
                setTimeout(() => {
                    this.searchAre = true;
                }, 0);
            }
        },
        async AsgActionEdit(item) {
            await this.clear();
            await EquimentAssignamentNew.list(item.EanID, 0, this.$fun.getUserID()).then(
                (resp) => {
                    if (resp.status == 200) {
                        console.log("resp.data", resp.data);
                        this.worker = resp.data;
                        this.itemsEquipmentAssignament = resp.data.ItemsDetail;
                    }
                }
            );
            this.filterEquipment.CgeTypeAssigns = item.EanTypeAssigns;
            this.getphotoBD();
            this.dialogAssignment = true;
        },
        addEquipmentWorker(item) {
            this.itemsComponent.splice(this.itemsComponent.indexOf(item), 1);
            this.itemsEquipmentAssignament.push(item);
            this.worker.EanNumAnydesk = item.CgeAnydesk;
            this.worker.EanHostName = item.CgeHostname;
        },
        deleteEquipmentWorker(item) {
            console.log("item", item);
            // EadID
            if (item.EadID == null) {
                this.itemsEquipmentAssignament.splice(this.itemsEquipmentAssignament.indexOf(item), 1);
                this.changeTypeAssign();
            } else {
                this.itemsEquipmentAssignament = this.itemsEquipmentAssignament.filter((item) => {
                    return item.EadID != item.EadID;
                });
                this.changeTypeAssign();
            }
        },
        async changeTypeAssign() {
            if (this.worker.EanID == "" || this.worker.EanID == null) {
                this.clear();
            }
            this.loading = true;
            await TicEquipmentService.list(this.filterEquipment, this.$fun.getUserID()).then((r) => {
                if (r.status == 200) {
                    this.itemsComponent = r.data;
                    this.loading = false;
                }
            });
        },
        async searchTypeAssign() {
            this.loading = true;
            await TicEquipmentService.list(this.filterEquipment, this.$fun.getUserID()).then((r) => {
                if (r.status == 200) {
                    this.itemsComponent = r.data;
                    // console.log("r.data", r.data);
                    this.loading = false;
                }
            });
        },
        clearHeaders() {
            const headersToRemove = [
                "PrsDocumentNumber",
                "NtpFullName",
                "EanZoneName",
                "AreName",
            ];

            headersToRemove.forEach((headerValue) => {
                const indexToRemove = this.config.headers.findIndex(
                    (header) => header.value === headerValue
                );
                if (indexToRemove !== -1) {
                    this.config.headers.splice(indexToRemove, 1);
                }
            });
        },
        AsgCharacteristics(row) {
            this.filterCharacteristics.CgeID = row.CgeID;
            this.dialogCharacteristics = true;
            this.CgeIDGroup = row.DedHelper2 ? parseInt(row.DedHelper2) : 0;
        },
        saveCharacteristics(item) {
            if (item.EctValueCharacteristics == "") {
                this.$fun.alert("Ingresar valor de la característica", "warning");
                return;
            }
            item.UsrCreateID = this.$fun.getUserID();
            item.CgeID = this.filterCharacteristics.CgeID;
            item.save();
        },
        AsgAccessory(row) {
            // console.log('AsgAccessory', row)
            this.workDetail = row;
            this.filterCharacteristicsOrAccessory.CgeID = row.CgeID;
            this.loadDevicesHistoryAccesory(() => {
                this.listAccessoriesAvailables(() => this.dialogAccessory = true)
            })
        },
        saveAccessory(item) {
            item.UsrCreateID = this.$fun.getUserID();
            item.CgeID = this.filterCharacteristicsOrAccessory.CgeID;

            if (item.EayState == "" || !item.EayState > 0) {
                this.$fun.alert("Seleccionar estado del Accesorio", "warning");
                return;
            }
            item.save();
        },
        async inizializeCamera() {
            try {
                this.dialogCamera = true;
                // this.stream = await navigator.mediaDevices.getUserMedia({ video: true });
                // this.$refs.video.srcObject = this.stream;
            } catch (error) {
                console.error("Error al acceder a la cámara:", error);
            }
        },
        captureImage() {
            const video = this.$refs.video;
            const canvas = this.$refs.canvas;
            const contexto = canvas.getContext("2d");

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            contexto.drawImage(video, 0, 0, canvas.width, canvas.height);

            if (this.isPhotoAssign) {
                this.EanPhotoAssign = canvas.toDataURL("image/png");
            } else {
                this.EanPhotoDevolution = canvas.toDataURL("image/png");
            }

            this.stopCamera();
        },
        handlePhotoConfirmed(imageDataUrl) {
            console.log("Foto confirmada:", imageDataUrl);
            this.dialogCamera = false;
            if (this.isPhotoAssign) {
                this.EanPhotoAssign = imageDataUrl;
            } else {
                this.EanPhotoDevolution = imageDataUrl;
            }
        },
        stopCamera() {
            this.dialogCamera = false;
            // if (this.stream) {
            // 	this.stream.getTracks().forEach(track => track.stop());
            // 	this.stream = null;
            // }
        },
        getphotoBD() {
            GenUploadFiles.getFile("routePrueba", this.worker.EanPhotoAssign, true)
                .then((base64) => {
                    this.EanPhotoAssignDB = base64;
                })
                .catch((error) => console.error("Error al obtener imagen:", error));

            GenUploadFiles.getFile(
                "routePrueba",
                this.itemsDevolutionAbsolute.EanPhotoDevolution,
                true
            )
                .then((base64) => {
                    this.EanPhotoDevolutionDB = base64;
                })
                .catch((error) => console.error("Error al obtener imagen:", error));
        },
        validatedItems(item) {
            if (!item.EayBrand && !item.EayModel && !item.EaySerie) {
                return true;
            } else {
                return false;
            }
        },
        showReleaseAccesory(EanID) {
            const details = this.itemsDevolutionAbsolute?.ItemsDetail ?? []
            const categoryEquipment = details.find((item) => item.EanID === EanID)
            return categoryEquipment?.ItemsAccessory?.length > 0;
        },
        modalDevolutionAccesory(itemDetail) {
            this.EadID = itemDetail.EadID;
            this.dialogAccesoryDevolution = true;
            // this.dialogAccesoryDevolution.find(x => x.EadID == EadID);
        },
        loadDevicesHistoryAccesory(callback = () => { }) {
            const CgeID = this.filterCharacteristicsOrAccessory.CgeID;
            _serviceAccesorio.listDevicesHistory({ CgeID, OnlyAsigned: 1 }, this.$fun.getUserID()).then(resp => {
                this.itemsAccesoryHistory = resp.status == 200 ? resp.data : [];
                callback();
            })
        },
        listAccessoriesAvailables(callback = () => { }) {
            const params = { EayAccessory: null, Search: "" }
            _serviceAccesorio.list(params, this.$fun.getUserID()).then(resp => {
                this.itemsAccesoryAvailables = resp.status == 200 ? resp.data.map(item => ({
                    ...item,
                    EayAccessoryFullName: `${item.EayAccessoryName} ${item.EayPhoneNumber ? 'Tel: ' + item.EayPhoneNumber + ' |' : ''} ${item.EayObservation} ${item.EayBrandName} ${item.EayModelName} ${item.EaySerie}`
                })) : [];
                callback();
            })
        },
        saveAsignacionAccesory() {

            console.log(this.workDetail);

            if (this.filterCharacteristicsOrAccessory.CgeID == undefined || this.filterCharacteristicsOrAccessory.CgeID == null || this.filterCharacteristicsOrAccessory.CgeID == "") {
                this.$fun.alert("Seleccione un equipo", "info");
                return;
            }
            if (this.EayID == null || this.EayID == "") {
                this.$fun.alert("Seleccione un accesorio disponible", "info");
                return;
            }

            this.$fun.alert("Asignar Accesorio al equipo seleccionado ?", "question").then((res) => {
                if (res.value) {
                    const messageResult = "Accesorio asignado correctamente";
                    const history = {
                        AahcID: 0,
                        EayID: this.EayID,
                        CgeID: this.filterCharacteristicsOrAccessory.CgeID,
                        EanID: this.workDetail?.EanID,
                        EadID: this.workDetail?.EadID,
                        AahObservation: null,
                        EayStatus: null,
                        DateDevolution: null,
                        SecStatus: 1,
                        UsrCreateID: this.$fun.getUserID()
                    }
                    this.saveOrUpdateHistoryAccesory([history], messageResult, () => this.EayID = null)
                }
            })
        },
        removeAsignacionAccesory(item) {
            this.formAccDevolution = { ...item, EayStateDevolution: 0, AahObservation: '' };
            this.dialogUnassignament = true;
        },
        saveDevolutionAccessory() {
            if (!this.formAccDevolution.EayStateDevolution > 0) {
                this.$fun.alert("Debe seleccionar un estado de devolución", "info");
                return;
            }

            const history = {
                AahcID: this.formAccDevolution.AahcID,
                EayID: this.formAccDevolution.EayID,
                CgeID: this.formAccDevolution.CgeID,
                EanID: this.workDetail?.EanID,
                EadID: this.workDetail?.EadID,
                EayStatus: this.formAccDevolution.EayStateDevolution,
                AahObservation: this.formAccDevolution.AahObservation,
                DateDevolution: new Date(),
                SecStatus: 1,
                UsrCreateID: this.$fun.getUserID()
            }

            this.$fun.alert("Liberar Accesorio del equipo ?", "question").then((res) => {
                if (res.value) {
                    const messageResult = "Accesorio liberado correctamente";
                    this.saveOrUpdateHistoryAccesory([history], messageResult, () => {
                        this.formAccDevolution.EayStatusAssignament = 0;
                        this.formAccDevolution.EayState = null;
                        this.dialogUnassignament = false;
                    })
                }
            })
        },
        saveOrUpdateHistoryAccesory(histories, message, callback = () => { }, executeFunc = true) {
            console.log(histories);
            _serviceAccesorio.SaveHistoryAccessory(histories, this.$fun.getUserID()).then((response) => {
                if (response.status == 200) {
                    this.$fun.alert(message, "success");
                    if (executeFunc) {
                        this.loadDevicesHistoryAccesory(callback)
                        this.listAccessoriesAvailables();
                    } else {
                        callback();
                    }
                }
            });
        },
        assignamentWithUsersExpired() {
            EquimentAssignamentNew.assignamentWithUsersExpired({ EanStatus: 1 }, this.$fun.getUserID()).then((response) => {
                if (response.status == 200) {
                    // console.log(response.data)
                    this.expiredContractsList = response.data;
                    if (this.expiredContractsList.length > 0) {
                        this.dialogExpiredContracts = true;
                        this.isAlertExpanded = false;
                    }
                }
            });
        },
        loadEquipmentModels() {
            const self = this;
            EquipmentModelService.list("", this.$fun.getUserID()).then(function (resp) {
                if (resp.status == 200) {
                    self.equipmentModels = resp.data;
                }
            });
        },
    },
    computed: {
        filtereditemsEquipmentAssignament() {
            return this.itemsEquipmentAssignament.filter(
                (item) => item.SecStatus !== 0
            );
        },
        filtereditemsComponent() {
            return this.itemsComponent.filter(
                (item) =>
                    !this.itemsEquipmentAssignament.some(
                        (equipment) => equipment.CgeID === item.CgeID
                    )
            );
        },
        getAccesoriesDevolution() {
            const accessoriesDevolution = this.accesoriesDevolution.find(x => x.EadID == this.EadID);
            const itemsDevolution = accessoriesDevolution?.ItemsAccessory ?? [];
            return itemsDevolution.filter(x => x.DateDevolution == null);
        }
    },
    watch: {
        "filter.CgeTypeAssigns"() {
            if (this.filter.CgeTypeAssigns == 1) {
                this.clearHeaders();

                const headersToAdd = [{ text: "Area", value: "AreName" }];

                let contador_initial = 2;
                headersToAdd.forEach((header) => {
                    const headerExists = this.config.headers.some(
                        (h) => h.value === header.value
                    );
                    if (!headerExists) {
                        this.config.headers.splice(contador_initial, 0, header);
                    }
                });
            } else if (this.filter.CgeTypeAssigns == 2) {
                this.clearHeaders();

                const headersToAdd = [
                    { text: "Area", value: "AreName" },
                    { text: "DNI", value: "PrsDocumentNumber", width: 80 },
                    { text: "Apellidos y Nombres", value: "NtpFullName" },
                ];

                let contador_initial = 2;
                headersToAdd.forEach((header) => {
                    const headerExists = this.config.headers.some(
                        (h) => h.value === header.value
                    );
                    if (!headerExists) {
                        this.config.headers.splice(contador_initial, 0, header);
                        contador_initial++;
                    }
                });
            } else if (this.filter.CgeTypeAssigns == 3) {
                this.clearHeaders();

                const headersToAdd = [{ text: "Zona", value: "EanZoneName" }];

                let contador_initial = 2;
                headersToAdd.forEach((header) => {
                    const headerExists = this.config.headers.some(
                        (h) => h.value === header.value
                    );
                    if (!headerExists) {
                        this.config.headers.splice(contador_initial, 0, header);
                        contador_initial++;
                    }
                });
            } else {
                this.clearHeaders();

                const headersToAdd = [
                    { text: "Area", value: "AreName" },
                    { text: "DNI", value: "PrsDocumentNumber", width: 80 },
                    { text: "Apellidos y Nombres", value: "NtpFullName" },
                    { text: "Zona", value: "EanZoneName" },
                ];

                let contador_initial = 2;
                headersToAdd.forEach((header) => {
                    const headerExists = this.config.headers.some(
                        (h) => h.value === header.value
                    );
                    if (!headerExists) {
                        this.config.headers.splice(contador_initial, 0, header);
                        contador_initial++;
                    }
                });
            }
            this.filter.AreID = null;
            this.filter.EanZone = null;
        },
    },

    saveNewModel() {
        const self = this;
        const name = this.newModelName.trim();
        if (!name) {
            this.$fun.alert("Ingrese un nombre de modelo", "warning");
            return;
        }
        const model = {
            EmdID: 0,
            EmdName: name,
            SecStatus: 1,
            UsrCreateID: self.$fun.getUserID(),
        };
        EquipmentModelService.save(model, self.$fun.getUserID()).then(function (saveResp) {
            if (saveResp.status == 200) {
                self.$fun.alert("Modelo agregado correctamente", "success");
                self.showAddModelInput = false;
                self.newModelName = '';
                self.loadEquipmentModels();
            }
        });
    },
    mounted() {
        this.loadEquipmentModels();
        this.assignamentWithUsersExpired();
    },
};
</script>

<style scoped>
::v-deep(.v-dialog--fullscreen) {
    /* backdrop-filter: blur(2px) !important; */
    background-color: rgba(0, 0, 0, 0.6) !important;
}

.modern-header-modal {
    background: linear-gradient(135deg, #606060 0%, #525c64 100%);
    padding: 12px;
    color: white;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

/* Header moderno */
.modern-header {
    background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
    padding: 12px;
    color: white;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    background: rgba(255, 255, 255, 0.2);
    padding: 8px;
    border-radius: 12px;
    backdrop-filter: blur(10px);
}

.header-text {
    flex: 1;
}

.header-title {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    line-height: 1.2;
}

.header-subtitle {
    font-size: 14px;
    opacity: 0.9;
    margin: 4px 0 0 0;
    font-weight: 300;
}

.header-actions {
    display: flex;
    gap: 8px;
}

.clear-btn,
.close-btn {
    background: rgba(255, 255, 255, 0.15) !important;
    backdrop-filter: blur(10px);
    transition: all 0.3s ease;
}

.clear-btn:hover,
.close-btn:hover {
    background: rgba(255, 255, 255, 0.25) !important;
    transform: scale(1.05);
}

/* Contenido del diálogo */
.dialog-content {
    flex: 1;
    overflow-y: auto;
    background: #f8fafc;
}

.content-row {
    /* margin: 0; */
    min-height: calc(100vh - 200px);
    width: 100%;
    max-width: 100%;
}

.left-panel,
.right-panel {
    /* padding: 12px; */
}

/* Tarjetas de sección */
.section-card {
    background: white;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    border: 1px solid #e2e8f0;
    transition: all 0.3s ease;
    height: fit-content;
}

.section-card:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}

.section-card.loading {
    opacity: 0.7;
    pointer-events: none;
}

.section-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-bottom: 16px;
    border-bottom: 2px solid #f1f5f9;
    margin-bottom: 16px;
}

.section-icon {
    background: rgba(102, 126, 234, 0.1);
    padding: 8px;
    border-radius: 8px;
}

.section-title {
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
    margin: 0;
}

.form-content {
    position: relative;
}

/* Inputs modernos */
.modern-input {
    margin-bottom: 8px;
}

.modern-input .v-input__slot {
    background: #f8fafc !important;
    transition: all 0.3s ease;
}

.modern-input .v-input--is-focused .v-input__slot {
    background: white !important;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2) !important;
}

/* Botones modernos */
.save-btn {
    border-radius: 8px !important;
    text-transform: none !important;
    font-weight: 600 !important;
    padding: 8px 24px !important;
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3) !important;
}

.date-helper-btn {
    background: rgba(33, 150, 243, 0.1) !important;
    border-radius: 8px !important;
}

.camera-btn {
    background: rgba(255, 152, 0, 0.1) !important;
    border-radius: 8px !important;
}

/* Tabla moderna */
.table-container {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
}

.modern-table {
    background: white;
}

.modern-table .v-data-table__wrapper {
    border-radius: 8px;
}

.modern-table th {
    background: #f8fafc !important;
    color: #475569 !important;
    font-weight: 600 !important;
    border-bottom: 2px solid #e2e8f0 !important;
}

.modern-table td {
    border-bottom: 1px solid #f1f5f9 !important;
}

.modern-table tr:hover {
    background: #f8fafc !important;
}

/* Chips y elementos especiales */
.date-chip {
    background: #e0f2fe;
    color: #0277bd;
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
}

.action-btn {
    border-radius: 6px !important;
    transition: all 0.3s ease;
}

.action-btn:hover {
    transform: scale(1.1);
}

.add-btn {
    box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3) !important;
}

/* Búsqueda */
.search-container {
    position: sticky;
    top: 0;
    z-index: 10;
    background: white;
    padding: 8px 0;
}

.search-input .v-input__slot {
    background: #f8fafc !important;
    border: 2px solid #e2e8f0 !important;
}

.search-input .v-input--is-focused .v-input__slot {
    border-color: #667eea !important;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
}

/* Sección de equipos */
.equipment-section {
    border-top: 2px solid #f1f5f9;
    padding-top: 24px;
}

/* Foto */
.photo-container {
    display: flex;
    justify-content: center;
}

.photo-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    border: 3px solid white;
}

.assignment-photo {
    max-width: 300px;
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
}

/* Tabla de equipos disponibles */
.available-equipment-table {
    max-height: 500px;
}

/* Responsivo */
@media (max-width: 1264px) {
    .content-row {
        flex-direction: column;
    }

    .left-panel,
    .right-panel {
        /* padding: 8px; */
    }

    .section-card {
        padding: 16px;
        margin-bottom: 16px;
    }
}

@media (max-width: 600px) {
    .modern-header {
        padding: 16px;
    }

    .header-title {
        font-size: 20px;
    }

    .header-subtitle {
        font-size: 12px;
    }

    .section-card {
        padding: 12px;
    }

    .section-title {
        font-size: 16px;
    }
}

/* Animaciones */
.dialog-transition-enter-active,
.dialog-transition-leave-active {
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.dialog-transition-enter,
.dialog-transition-leave-to {
    opacity: 0;
    transform: scale(0.9) translateY(-50px);
}

.floating-alert-card {
    position: fixed;
    bottom: 4px;
    right: 12px;
    width: 350px;
    z-index: 9999;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.alert-content {
    overflow-y: auto;
    max-height: 400px;
    /* Adjust max height for the list */
    background-color: white;
}

.selectable-text {
    user-select: text !important;
    -webkit-user-select: text !important;
    -moz-user-select: text !important;
    -ms-user-select: text !important;
    cursor: text !important;
}

.pointer {
    cursor: pointer;
}
</style>
